// A team member (sub-user) uses the account owner's plan, so only the owner can
// buy one. Mirrors the backend's !empty($member->super_admin), which refuses
// checkout for these members.
export const isTeamMember = (member) => {
  const owner = member?.super_admin;
  return !!owner && String(owner) !== "0";
};
